<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <Toasts></Toasts>
      <b-row class="justify-content-center">
        <b-col md="8">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form v-if="!showSuccessMsg">
                  <h1>Forgot password</h1>
                  <p class="text-muted">Please enter your email address to sent you the recovery email</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text>
                        <i class="icon-user"></i>
                      </b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="email"
                      class="form-control"
                      v-model="email"
                      placeholder="Email"
                      autocomplete="email"
                    />
                  </b-input-group>
                  <b-row>
                    <b-col cols="6">
                      <b-button
                        variant="primary"
                        @click="handleForgotPassword()"
                        class="px-4"
                        >Send email</b-button
                      >
                    </b-col>
                    <b-col cols="6" class="text-right">
                      <b-button variant="link" class="px-0"
                      @click="handleGotoLogin()"
                        >Go back</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
                <div v-else>
                  <h1>Email sent</h1><br/>
                  <p class="text-muted">An email was sent to the specified address. </p>
                  <p class="text-muted">Please follow the instructions in the email to reset your password.</p>
                  <p class="text-muted">You will be redirected shortly to the login page</p>
                </div>
              </b-card-body>
            </b-card>
            <b-card
              no-body
              class="text-white bg-primary py-5 d-md-down-none"
              style="width:44%"
            >
              <b-card-body class="text-center justify-content-center">
                <img
                  class="navbar-brand-full"
                  src="img/brand/new_logo2.png"
                  width="270em"
                  height="auto"
                  alt="CoreUI Logo"
                />
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import router from "../../router";
export default {
  components: {
    router
  },
  name: "ForgotPassword",
  data: function() {
    return {
      email: "",
      showSuccessMsg: false
    };
  },
  methods: {
    handleForgotPassword() {
      this.showSuccessMsg = false;
      this.$http
        .post("api/auth/forgotPassword.php", {
          email: this.email,
          portal: "customers"
        })
        .then(
          res => {
            if (res.data.error) {
              this.$toast.error(res.data.message);
            } else {
              this.$toast.success(res.data.message);
              this.showSuccessMsg = true;
              window.setTimeout(function(){
                router.push('/pages/login');
              }, 5000);
            }
          },
          err => {
            console.log(err);
            this.$toast.error(err.message);
          }
        );
    },
    handleGotoLogin() {
      router.push('/pages/login');
    }
  }
};
</script>
